module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/babel-runtime/core-js/object/define-property.js
// module id = 941
// module chunks = 48 49 50